<template>
  <div
    class="flex w-full flex-col gap-y-4 px-6 py-4"
    data-testid="rx-step-prescription"
  >
    <SupportHeadline
      v-if="isOverlayAvailable"
      :text="linkText"
      class="my-4"
      data-testid="rx-prescription-overlay"
      @click="showOverlay"
    />

    <RxSelectOption
      data-testid="rx-add-prescription"
      icon="IconFielmannGlass"
      :title="$t('rxConfigurator.prescriptionValues.add.title')"
      :selected="selectedOption === 'continue'"
      collapsible
      @click:select="selectOption('continue')"
    >
      <div class="px-6 pb-4">
        <p>{{ $t('rxConfigurator.prescriptionValues.add.description') }}</p>
      </div>
    </RxSelectOption>

    <RxSelectOption
      v-if="isSightPrescriptionCheckAvailable"
      data-testid="rx-sight-prescription-check"
      icon="IconFielmannWebcam"
      :title="$t(`rxConfigurator.sightPrescriptionCheck.title`)"
      :selected="selectedOption === 'check'"
      collapsible
      @click:select="selectOption('check')"
    >
      <div class="px-6 pb-4">
        <p>{{ $t('rxConfigurator.sightPrescriptionCheck.description') }}</p>
        <p class="mt-2 text-xs text-shade-500">
          {{ $t('rxConfigurator.sightPrescriptionCheck.info') }}
        </p>
      </div>
    </RxSelectOption>

    <RxSelectOption
      data-testid="rx-schedule-appointment"
      icon="IconFielmannStore"
      :title="$t('rxConfigurator.appointment.title')"
      :selected="selectedOption === 'appointment'"
      collapsible
      @click:select="selectOption('appointment')"
    >
      <div class="px-6 pb-4">
        <p>{{ $t('rxConfigurator.appointment.description') }}</p>
      </div>
    </RxSelectOption>
  </div>

  <Overlay
    v-if="isOverlayAvailable"
    portal-target="#rx-find-portal"
    :title="overlayTitle"
    :open="isOverlayOpen"
    layout="right"
    enter-from="right"
    @update:open="isOverlayOpen = false"
  >
    <div v-for="content in overlayContent" :key="content._uid">
      <component :is="content.component" :blok="content" />
    </div>
  </Overlay>
</template>

<script setup lang="ts">
const emit = defineEmits(['ui:update'])

const $currentShop = useCurrentShop()

const isSightPrescriptionCheckAvailable = computed(() =>
  Boolean($currentShop.value.sightPrescriptionCheckUrl),
)

const selectedOption = ref<RxMainAction>('continue')

const selectOption = (action: RxMainAction) => {
  selectedOption.value = action

  emit('ui:update', {
    mainAction: action,
  })
}

const {
  overlayTitle,
  overlayContent,
  linkText,
  open: isOverlayOpen,
  show: showOverlay,
  available: isOverlayAvailable,
} = await useOverlay(RxOverlays.PRESCRIPTION_VALUES_FIND)
</script>
